var ThermalConnectionTypes = {
    RELIEF : "RELIEF",
    DIRECT : "DIRECT",
    NO : "NO",
};
module.exports = ThermalConnectionTypes;

